// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","editorWrapper":"_2xi9ybpVJx26C_mgBxqHL_","error":"_3tcaYoHV7-m_Iqmk73_6NO","uploadThesisButton":"mSxZQIC2xvfF6WsQMLpAO"};